import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getContentEntityStructuresLookups } from './thunks';
import { ContentEntityStructureState } from './types';

export const name = 'contentEntityStructures';

const initialState: ContentEntityStructureState = {
  lookups: {
    data: [],
    status: 'idle',
  },
};

export const getContentEntityStructuresLookupsAsync = createAsyncThunk(
  name + '/getContentEntityStructuresLookups',
  getContentEntityStructuresLookups
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContentEntityStructuresLookupsAsync.pending, (state) => {
        state.lookups.status = 'loading';
      })
      .addCase(
        getContentEntityStructuresLookupsAsync.fulfilled,
        (state, action) => {
          state.lookups = {
            data: action.payload,
            status: 'idle',
          };
        }
      )
      .addCase(getContentEntityStructuresLookupsAsync.rejected, (state) => {
        state.lookups.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
